import * as React from "react";
import { VariantProps } from "class-variance-authority";

import { cn } from "@/src/lib/utils";
import { headingVariants } from "./typographyVariants";

interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export function Heading({
  as: Component = "h2",
  size,
  className,
  children,
  ...props
}: HeadingProps) {
  return (
    <Component
      className={cn(headingVariants({ size }), className)}
      {...props}
    >
      {children}
    </Component>
  );
}